import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  SecondaryTopNav,
  Text,
} from "@certn/cascadia-react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  onComplete?: () => void;
  isDisabled?: boolean;
  submitting?: boolean;
}

export function AtsIntegrationStepHeader({
  onComplete,
  isDisabled,
  submitting,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isCancelModalVisible, setCancelModalVisible] = useState(false);

  const showCancelModal = () => {
    setCancelModalVisible(true);
  };

  const handleCancelConfirm = () => {
    navigate("/settings/ats-integrations");
  };

  const handleCancelCancel = () => {
    setCancelModalVisible(false);
  };

  return (
    <>
      <SecondaryTopNav
        testID="ats-integration-setup-top-nav"
        leftIcon="close"
        onleftIconOnPress={showCancelModal}
      >
        <PrimaryButton
          onPress={onComplete}
          isDisabled={isDisabled}
          isLoading={submitting}
          testID="ats-integration-setup-top-nav-connect-button"
        >
          {t("Create integration")}
        </PrimaryButton>
      </SecondaryTopNav>
      <Modal isOpen={isCancelModalVisible}>
        <Dialog width="560px">
          <DialogHeader onClose={handleCancelCancel}>
            {t("Cancel integration")}
          </DialogHeader>
          <DialogContent>
            <Text style="form/body-primary">
              <Trans>
                You are about to leave the integration process. Any information
                you have entered so far will be lost.
              </Trans>
            </Text>
          </DialogContent>
          <DialogFooter>
            <BasicButton onPress={handleCancelCancel}>
              {t("Go back")}
            </BasicButton>
            <PrimaryButton
              onPress={handleCancelConfirm}
              testID="cancel-integration-confirm-button"
            >
              {t("Cancel integration")}
            </PrimaryButton>
          </DialogFooter>
        </Dialog>
      </Modal>
    </>
  );
}
